import React, { useState } from 'react';
import { Card, Form, Input, Button, Typography, message } from 'antd';
import { login } from '../services/api';

const { Title, Paragraph } = Typography;

const LoginGate = ({ onSuccess }) => {
  const [submitting, setSubmitting] = useState(false);

  const handleFinish = async (values) => {
    setSubmitting(true);
    try {
      const result = await login(values.username, values.password);
      // 保存token到本地存储
      if (result.token) {
        localStorage.setItem('token', result.token);
      }
      onSuccess && onSuccess();
    } catch (e) {
      message.error(e.message || '登录失败');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f5f5f5',
      padding: 16
    }}>
      <Card style={{ width: 360, maxWidth: '100%' }}>
        <div style={{ textAlign: 'center', marginBottom: 16 }}>
          <Title level={4} style={{ marginBottom: 4 }}>TikTok账号管理ERP</Title>
          <Paragraph type="secondary" style={{ margin: 0 }}>请输入访问密码</Paragraph>
        </div>
        <Form layout="vertical" onFinish={handleFinish} autoComplete="on">
          <Form.Item
            name="username"
            label="账号"
            initialValue=""
            rules={[{ required: true, message: '请输入账号' }]}
          >
            <Input placeholder="账号" autoComplete="username" />
          </Form.Item>
          <Form.Item
            name="password"
            label="密码"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input.Password placeholder="请输入密码" autoFocus autoComplete="current-password" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" block loading={submitting}>
              登录
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default LoginGate;


